import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { Clock, Calendar as CalIcon, User, Stethoscope, CheckCircle, Trash2, Filter, ChevronDown } from 'lucide-react';

const CalendarView = ({ appointments, handleApprove, handleDelete }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [filterStatus, setFilterStatus] = useState('Hepsi');

  const getFormattedDate = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().split('T')[0];
  };

  // 1. Takvimde seçilen güne ait randevular
  const selectedDayApts = appointments.filter(apt => apt.date === getFormattedDate(selectedDate));

  // 2. TÜM RANDEVULAR (Seçilen filtreye göre)
  const allFilteredApts = appointments
    .filter(apt => filterStatus === 'Hepsi' || apt.status === filterStatus)
    .sort((a, b) => new Date(a.date) - new Date(b.date) || a.time.localeCompare(b.time));

  // Takvim günlerini işaretleme
  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const dateStr = getFormattedDate(date);
      const dayApts = appointments.filter(apt => apt.date === dateStr);
      if (dayApts.length > 0) {
        return dayApts.some(a => a.status === 'Beklemede') ? 'has-pending' : 'has-approved';
      }
    }
    return null;
  };

  return (
    <div className="calendar-mega-wrapper anim-in">
      {/* ÜST BÖLÜM: TAKVİM VE SEÇİLİ GÜN ÖZETİ */}
      <div className="top-management-grid">
        <div className="calendar-card-premium">
          <Calendar 
            onChange={setSelectedDate} 
            value={selectedDate} 
            locale="tr-TR"
            tileClassName={tileClassName}
          />
          <div className="calendar-info-legend">
            <span><i className="dot yellow"></i> Bekleyen Randevu</span>
            <span><i className="dot green"></i> Hepsi Onaylı</span>
          </div>
        </div>

        <div className="selected-day-preview">
          <div className="preview-header">
            <CalIcon size={20} />
            <h4>{selectedDate.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'long' })}</h4>
          </div>
          <div className="preview-body">
            {selectedDayApts.length > 0 ? (
              selectedDayApts.map(apt => (
                <div key={apt.id} className="mini-apt-card">
                  <span className="mini-time">{apt.time}</span>
                  <span className="mini-name">{apt.fullName}</span>
                  <div className={`mini-status ${apt.status === 'Onaylandı' ? 'ok' : 'wait'}`}></div>
                </div>
              ))
            ) : (
              <p className="no-apt-text">Bu tarihte randevu bulunmuyor.</p>
            )}
          </div>
        </div>
      </div>

      {/* ALT BÖLÜM: TÜM RANDEVULAR AKIŞI */}
      <div className="full-appointments-section">
        <div className="section-sticky-header">
          <div className="header-left">
            <h3>Tüm Randevu Akışı</h3>
            <span className="total-badge">{allFilteredApts.length} Toplam</span>
          </div>
          <div className="header-filters">
            {['Hepsi', 'Beklemede', 'Onaylandı'].map(s => (
              <button key={s} className={filterStatus === s ? 'active' : ''} onClick={() => setFilterStatus(s)}>{s}</button>
            ))}
          </div>
        </div>

        <div className="appointments-list-grid">
          {allFilteredApts.map(apt => (
            <div key={apt.id} className={`mega-apt-card ${apt.status === 'Beklemede' ? 'is-new' : ''}`}>
              <div className="mega-date-side">
                <span className="m-day">{apt.date.split('-')[2]}</span>
                <span className="m-month">{new Date(apt.date).toLocaleDateString('tr-TR', {month: 'short'})}</span>
              </div>
              
              <div className="mega-content-side">
                <div className="mega-top">
                  <div className="mega-user">
                    <User size={18} />
                    <strong>{apt.fullName}</strong>
                  </div>
                  <div className={`mega-badge ${apt.status === 'Onaylandı' ? 'approved' : 'pending'}`}>
                    {apt.status || 'Beklemede'}
                  </div>
                </div>
                
                <div className="mega-details">
                  <span><Stethoscope size={14} /> {apt.service?.title}</span>
                  <span><Clock size={14} /> {apt.time}</span>
                  <span><i className="phone-icon">📞</i> {apt.phone}</span>
                </div>
              </div>

              <div className="mega-actions">
                {apt.status !== 'Onaylandı' && (
                  <button onClick={() => handleApprove(apt.id)} className="m-btn approve"><CheckCircle size={20} /></button>
                )}
                <button onClick={() => handleDelete(apt.id)} className="m-btn delete"><Trash2 size={20} /></button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarView;